import React from "react";
import { NavLink } from "react-router-dom";
export const FocusHeader = () => {
    return (React.createElement("header", { className: "focus-header" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "focus-header-inner" },
                React.createElement(NavLink, { to: "/cs/seznam/nejblizsi-aukce", className: "app-logo-link" },
                    React.createElement("div", { className: "app-logo-block" },
                        React.createElement("span", { className: "sr-only" }, "Na \u00FAvodn\u00ED stranu")))))));
};
